module.exports = __webpack_public_path__ + "img/yiyangxian.734e5417.png";